import { HelmetProvider, Helmet } from "react-helmet-async";

const MetaTag = () => (
  <HelmetProvider>
    <div className="App">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Your Website Name",
            url: "https://www.welljanhitchemist.com/",
            logo: "https://welljanhitchemist.com/Logo.png",
          })}
        </script>
      </Helmet>
    </div>
  </HelmetProvider>
);

export default MetaTag;
